import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { CONTACT_INFO } from '../App';

const Concept = () => {
  const galleryImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_signature-studio-4/artifacts/uqxipzvo_ChatGPT%20Image%2011%20mai%202026%20a%CC%80%2017_01_03.png",
      alt: "The 70' Bar - Vue d'ensemble soirée"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_signature-studio-4/artifacts/jfjtrjns_ChatGPT%20Image%2011%20mai%202026%20a%CC%80%2017_13_32.png",
      alt: "L'Élégance Bar - Mariage avec lustre"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_signature-studio-4/artifacts/xr0140wx_ChatGPT%20Image%2011%20mai%202026%20a%CC%80%2016_45_08.png",
      alt: "Mediterranean Bar - Service cocktail"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_signature-studio-4/artifacts/1938gufy_Capture%20d%E2%80%99e%CC%81cran%202026-05-11%20a%CC%80%2016.37.07.png",
      alt: "Street Bar - Événement urbain"
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [galleryImages.length]);

  return (
    <div className="bg-black min-h-screen">
      {/* Hero with Background Image */}
      <section className="relative min-h-[60vh] flex items-center justify-center">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://customer-assets.emergentagent.com/job_signature-studio-4/artifacts/xr0140wx_ChatGPT%20Image%2011%20mai%202026%20a%CC%80%2016_45_08.png"
            alt="Mediterranean Bar - Service cocktail"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        
        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto text-center px-6 lg:px-12 py-24">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 
              data-testid="concept-title"
              className="font-display text-4xl sm:text-5xl lg:text-7xl tracking-tight text-white mb-4 font-bold"
            >
              Le concept<br />Studio Bar
            </h1>
            <div className="w-24 h-1 bg-white mx-auto mt-8"></div>
            <p className="text-lg lg:text-xl text-white/80 mt-8 max-w-2xl mx-auto">
              L'art de sublimer vos événements par le design
            </p>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="section-white py-20 px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
            {/* Text Content */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="lg:sticky lg:top-32"
            >
              {/* Main Statement */}
              <h2 className="font-display text-3xl lg:text-4xl xl:text-5xl text-black leading-tight mb-10 font-semibold">
                Des bars pensés comme des pièces centrales de l'événement.
              </h2>
              
              <div className="space-y-6">
                <p className="text-lg text-gray-600 leading-relaxed">
                  Chaque projet est conçu pour structurer l'espace et définir l'ambiance.
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Nos bars s'adaptent à tous les lieux, avec une grande liberté de formats, de finitions et de configurations.
                </p>
                <p className="text-lg text-black leading-relaxed font-medium">
                  Une nouvelle alliance entre scénographie, immersion et mixologie où le bar devient le cœur de l'expérience.
                </p>
              </div>

              {/* Key Point */}
              <div className="mt-12 p-8 bg-white border-2 border-black">
                <p className="text-black text-lg font-medium">
                  Le sur-mesure comme signature d'exception.
                </p>
              </div>
            </motion.div>

            {/* Image Carousel */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="aspect-[4/5] overflow-hidden relative bg-gray-100">
                <AnimatePresence mode="wait">
                  <motion.img
                    key={currentIndex}
                    src={galleryImages[currentIndex].src}
                    alt={galleryImages[currentIndex].alt}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                    className="w-full h-full object-cover absolute inset-0"
                  />
                </AnimatePresence>
                
                {/* Dots indicator */}
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
                  {galleryImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentIndex(index)}
                      className={`w-2 h-2 rounded-full transition-all ${
                        index === currentIndex ? 'bg-black w-6' : 'bg-black/30'
                      }`}
                    />
                  ))}
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Concept;
